import { Observable } from 'rxjs';
import { IndicadorEnum } from '../enums/indicador.enum';
import { DocumentosAdjuntosRequest } from '../interfaces/documentos-adjuntos-request';
import { EstadoDocumento } from '../interfaces/estado-documento';
import { GeneralResponseGeneric } from '../interfaces/general-response-generic';

export abstract class DocumentService {

    abstract requiredDocuments(): Observable<any[]>;
    abstract documentStatus(): Observable<EstadoDocumento[]>;

    abstract saveDocument(documentsRequest: DocumentosAdjuntosRequest): Observable<GeneralResponseGeneric<unknown, IndicadorEnum>>;
    abstract deleteDocument(): Observable<GeneralResponseGeneric<unknown, IndicadorEnum>>;
}
